import type { MouseEvent } from "react";

import { callAll } from "../../../../utils/call-all";
import { primeIcon } from "../../../icon";
import { useTableActionsMenuContext } from "../../table-actions-menu.context";
import type { TableActionsMenuTriggerViewProps, TriggerProps } from "./types-trigger";

/** ViewModel do TableActionsMenu.Trigger: ids e `aria-*` do gatilho e o clique que abre o menu e soma (`callAll`) o `onClick` da tela; sem JSX. */
export function useTableActionsMenuTrigger({
  icon = "ellipsis-v",
  className,
  onClick,
  ...rest
}: TriggerProps): TableActionsMenuTriggerViewProps {
  const { triggerRef, triggerId, menuId, ariaLabel, open, toggle, partTestId } =
    useTableActionsMenuContext();

  return {
    rest,
    id: triggerId,
    testId: partTestId("trigger"),
    icon: primeIcon(icon, 14),
    className,
    ariaLabel,
    expanded: open,
    controls: open ? menuId : undefined,
    onClick: callAll((event: MouseEvent<HTMLButtonElement>) => toggle(event), onClick),
    triggerRef,
  };
}
